<div class="loadingIndicator">
  <i class="pi pi-spin pi-spinner"></i>
  &nbsp;{{ 'APP.LOADING' | translate }}
</div>
